export default "__VITE_PUBLIC_ASSET__5329d2cc__"